import { render, staticRenderFns } from "./TypeaheadProd.vue?vue&type=template&id=59e05ce4"
import script from "./TypeaheadProd.vue?vue&type=script&lang=js"
export * from "./TypeaheadProd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports